import Vue from "vue";
import VueRouter from "vue-router";

Vue.use(VueRouter);
import { store } from "@/store/appStore";

function hasQueryParams(route) {
  return !!Object.keys(route.query).length;
}

export default function createRouter(props = {}) {
  const routes = [
    {
      name: "list",
      path: "/events",
      component: () =>
        import(/* webpackChunkName: "routed-main" */ "@/views/List/List.vue"),
      props: route => ({
        ...props,
        apiKey: route.query.apiKey || store?.state?.apiKey
      })
    },
    {
      name: "searchTeaser",
      path: "/",
      component: () =>
        import(
          /* webpackChunkName: "routed-search-teaser" */ "@/views/SearchTeaser/SearchTeaser.vue"
        ),
      props: props
    },
    {
      name: "teaser",
      path: "/teaser",
      component: () =>
        import(
          /* webpackChunkName: "routed-teaser" */ "@/views/Teaser/Teaser.vue"
        ),
      props: route => ({
        ...props,
        apiKey: route.query.apiKey || store?.state?.apiKey
      })
    },
    {
      name: "detailView",
      path: "/events/:eventId/:momentId",
      component: () =>
        import(
          /* webpackChunkName: "routed-main" */ "@/views/DetailView/DetailView.vue"
        ),
      props: route => ({
        apiKey: route.query.apiKey || store?.state?.apiKey,
        id: props.id,
        eventId: route.params.eventId,
        momentId: route.params.momentId
      })
    }
  ];

  const Router = new VueRouter({
    mode: "history",
    base: process.env.BASE_URL,
    routes
  });

  Router.beforeEach((to, from, next) => {
    if (!hasQueryParams(to) && hasQueryParams(from)) {
      next({ ...to, query: { ...to.query, ...from.query } });
    } else {
      next();
    }
  });

  return Router;
}
